import LocalStoragePreferences from '../../utils/local-storage-preferences';

export interface PermissionObject {
  add: string[];
  remove: string[];
  type: string;
  // eslint-disable-next-line camelcase
  membership_id: string;
}

function extract(start: number, end: number, obj: PermissionObject): PermissionObject {
  const returnObject: PermissionObject = {
    add: [], remove: [], type: obj.type, membership_id: obj.membership_id,
  };
  const targetCount = end - start;
  const objAddCount = obj.add.length;
  const currentAddLength = () => returnObject.add.length;
  const currentRemLength = () => returnObject.remove.length;
  const currentTotalCount = () => currentAddLength() + currentRemLength();

  if (start < objAddCount) {
    const newAdds = obj.add.slice(start, end);
    returnObject.add.push(...newAdds);
  }

  if (currentTotalCount() < targetCount) {
    const offset = objAddCount - currentAddLength();
    const newStart = start - offset;
    const newEnd = end - currentAddLength();
    const newRems = obj.remove.slice(newStart, newEnd);
    returnObject.remove.push(...newRems);
  }

  return returnObject;
}

function splitPermissionRequest(obj: PermissionObject, limit?: number): PermissionObject[] {
  const totalCount = obj.add.length + obj.remove.length;
  const localLimit = new LocalStoragePreferences().getPermissionChangePayloadLimit();
  const limitPerObject = limit || localLimit || 100;

  if (totalCount < limitPerObject) {
    return [obj];
  }

  let start = 0;
  let end = limitPerObject;
  const objs: PermissionObject[] = [];

  while (start < totalCount) {
    objs.push(extract(start, end, obj));
    start += limitPerObject;
    end += limitPerObject;
  }

  return objs;
}

export default splitPermissionRequest;
